import { createRouter, createWebHistory } from 'vue-router';
import Index from '@/_components/Index.vue';
import Polo from '@/_components/Polo.vue';

const routes = [
  {
    path: '/special/tenkyu/10color/',
    name: 'index',
    component: Index,
  },
  {
    path: '/special/tenkyu/10color/polo/:id/',
    name: 'polo',
    component: Polo,
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes
});

export default router;
